// Миксин для работы со всеми страницами
import Vue from 'vue'

import VueRouter from 'vue-router'
import vuescroll from 'vuescroll'

Vue.use(VueRouter)
Vue.use(vuescroll)


const router = new VueRouter({
  mode: 'history'
})

Vue.prototype.$vuescrollConfig = {
  bar: {
    background: '#d8d8e3'
  }
}

export default {
  router
}
